'use strict';

exports.__esModule = true;
exports.getVisitorId = undefined;

var _cookie = require('./cookie');

var _logger = require('./logger');

// Retrives the visitor id from the visitor cookie
var _getVisitorId = function _getVisitorId() {
  var visitorCookie = (0, _cookie.getCookieValues)('visitor');

  if (visitorCookie) {
    return visitorCookie.vid;
  }
};

// returns the visitor id if available. Falls back to shopper id
var getVisitorId = function getVisitorId() {
  var visitorId = _getVisitorId();
  if (!visitorId) {
    (0, _logger.debug)('A user identifier was unable to be retrived');
  }
  return visitorId;
};

exports.getVisitorId = getVisitorId;